import { default as MuiListItemButton } from '@mui/material/ListItemButton';

/**
 * ListItemButton makes a list item interactive and clickable.
 *
 * Demos:
 *
 * - [List Item Button](https://unify.workiva.org/components/list?tab=code#list-item-button)
 *
 * API:
 *
 * - [ListItemButton API](https://unify.workiva.org/components/list?tab=props#listitembutton)
 */
export const ListItemButton = MuiListItemButton;
export {
  type ListItemButtonProps,
  listItemButtonClasses,
} from '@mui/material/ListItemButton';
export * from './listItemButtonModuleAugmentation';
